import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function UrlEncodeDecodeCalc() {
  const [mode, setMode] = useState('encode');
  const [input, setInput] = useState('https://example.com/?q=hello world');
  const [output, setOutput] = useState('');

  const run = () => {
    try {
      if (mode === 'encode') setOutput(encodeURIComponent(input));
      else setOutput(decodeURIComponent(input));
    } catch (e) { setOutput('Error: ' + e.message); }
  };

  return (
    <CalcShell look="cnet" title="URL Encoder / Decoder" subtitle="Percent-encode or decode URL query strings and special characters.">
      <div className="flex gap-2 border-b mb-4">
        {[['encode','Encode'],['decode','Decode']].map(([v,l]) => (
          <button key={v} className={`px-4 py-2 text-sm font-semibold ${mode===v?'border-b-2 border-blue-600 text-blue-700':'text-slate-500'}`} onClick={() => setMode(v)}>{l}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Input</label><textarea rows={7} value={input} onChange={e => setInput(e.target.value)} className="w-full" data-testid="url-input"/></div>
          <button onClick={run} className="px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700" data-testid="url-run">Run</button>
        </div>
        <div>
          <div className="field"><label>Output</label><textarea rows={7} value={output} readOnly className="w-full font-mono text-sm" data-testid="url-output"/></div>
          <button onClick={() => navigator.clipboard.writeText(output)} className="px-4 py-2 border rounded-lg">Copy</button>
        </div>
      </div>
    </CalcShell>
  );
}
